import React from 'react';
interface NavigationBarProps {
  currentScreen: string;
  navigateTo: (screen: string) => void;
}
export const NavigationBar = ({
  currentScreen,
  navigateTo
}: NavigationBarProps) => {
  const navItems = [{
    name: 'Home',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1518">
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" data-id="element-1519"></path>
          <polyline points="9 22 9 12 15 12 15 22" data-id="element-1520"></polyline>
        </svg>,
    screen: 'home'
  }, {
    name: 'Workouts',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1521">
          <path d="M18 8h1a4 4 0 0 1 0 8h-1" data-id="element-1522"></path>
          <path d="M6 8h-1a4 4 0 0 0 0 8h1" data-id="element-1523"></path>
          <path d="M8 8v8" data-id="element-1524"></path>
          <path d="M16 8v8" data-id="element-1525"></path>
          <path d="M12 8v8" data-id="element-1526"></path>
        </svg>,
    screen: 'workouts'
  }, {
    name: 'Progress',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1527">
          <path d="M3 3v18h18" data-id="element-1528"></path>
          <path d="m19 9-5 5-4-4-3 3" data-id="element-1529"></path>
        </svg>,
    screen: 'progress'
  }, {
    name: 'Nutrition',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1530">
          <path d="M12 2v8" data-id="element-1531"></path>
          <path d="M4.93 10.93 10 16" data-id="element-1532"></path>
          <path d="M19.07 10.93 14 16" data-id="element-1533"></path>
          <path d="M22 20H2" data-id="element-1534"></path>
          <path d="M12 16v4" data-id="element-1535"></path>
        </svg>,
    screen: 'nutrition'
  }, {
    name: 'Profile',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1536">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-1537"></path>
          <circle cx="12" cy="7" r="4" data-id="element-1538"></circle>
        </svg>,
    screen: 'profile'
  }];
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 max-w-md mx-auto" data-id="element-1539">
      <div className="flex justify-between items-center px-2" data-id="element-1540">
        {navItems.map(item => <button key={item.name} onClick={() => navigateTo(item.screen)} className={`flex flex-col items-center py-3 px-2 ${currentScreen === item.screen ? 'text-blue-500' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1541">
            <div className="w-6 h-6" data-id="element-1542">{item.icon}</div>
            <span className="text-xs mt-1" data-id="element-1543">{item.name}</span>
          </button>)}
      </div>
    </div>;
};